<template v-if="showUserDeBind">
  <div>
    <Scroll :height="height*0.9">
      <Spin fix v-show="isSpinShow" size="large" />
      <Tabs>
        <TabPane label="本微信绑定信息" icon="ios-cog-outline">
          <div v-if="hasPersonnel" style="text-align:center">
            <Divider orientation="left">已绑定工程人员信息</Divider>
            <div
              v-for="(value, key) in personnelArray"
              :value="value"
              :key="key"
              style="font-size: 18px;margin: 10px"
            >
              <Row>
                <Col span="8" style="text-align:right;">姓名：</Col>
                <Col span="16" style="text-align:left;">{{value.personnelName}}</Col>
              </Row>
              <Row>
                <Col span="8" style="text-align:right;">联系电话：</Col>
                <Col span="16" style="text-align:left;">{{value.personnelPhone}}</Col>
              </Row>
              <Row>
                <Col span="8" style="text-align:right;">证件号码：</Col>
                <Col span="16" style="text-align:left;">{{value.personnelIdcard}}</Col>
              </Row>
              <Row>
                <Button type="warning" style="float:right" @click="debind('personnel', value)">解除绑定</Button>
              </Row>
            </div>
          </div>
          <div v-if="hasHouseHolder" style="text-align:center">
            <Divider orientation="left">已绑定户主用户信息</Divider>
            <div
              v-for="(value, key) in customerArray"
              :value="value"
              :key="key"
              style="font-size: 18px;margin: 10px"
            >
              <Row>
                <Col span="8" style="text-align:right;">姓名：</Col>
                <Col span="16" style="text-align:left;">{{value.customerName}}</Col>
              </Row>
              <Row>
                <Col span="8" style="text-align:right;">联系电话：</Col>
                <Col span="16" style="text-align:left;">{{value.customerPhone}}</Col>
              </Row>
              <Row>
                <Col span="8" style="text-align:right;">证件号码：</Col>
                <Col span="16" style="text-align:left;">{{value.customerIdcard}}</Col>
              </Row>
              <Row>
                <Button
                  type="warning"
                  style="float:right"
                  @click="debind('householder', value)"
                >解除绑定</Button>
              </Row>
              <Divider orientation="left"></Divider>
            </div>
          </div>
          <div v-if="hasNotHouseHolder" style="text-align:center">
            <Divider orientation="left">绑定非户主用户信息</Divider>
            <div
              v-for="(value, key) in meterArray"
              :value="value"
              :key="key"
              style="font-size: 18px;margin: 10px"
            >
              <Row>
                <Col span="8" style="text-align:right;">地址：</Col>
                <Col span="16" style="text-align:left;">{{value.completeAddress}}</Col>
              </Row>
              <Row>
                <Col span="8" style="text-align:right;">设备编号：</Col>
                <Col span="16" style="text-align:left;">{{value.meterId}}</Col>
              </Row>
              <Row>
                <Button
                  type="warning"
                  style="float:right"
                  @click="debind('nothouseholder', value)"
                >解除绑定</Button>
              </Row>
            </div>
            <Divider orientation="left"></Divider>
          </div>
        </TabPane>
        <TabPane label="被绑定非户主用户信息" icon="ios-cog-outline">
          <div v-if="wxUserArray != undefined && wxUserArray.length > 0">
            <div
              v-for="(value, key) in  wxUserArray"
              :value="value"
              :key="key"
              style="text-align:center"
            >
              <Divider
                orientation="left"
              >{{value.customerInfo.customerName + " " + value.customerInfo.customerIdcard}}</Divider>
              <div
                v-for="(userObject, userObjectKey) in value.userList"
                :value="userObject"
                :key="userObjectKey"
                style="font-size: 18px;margin: 10px"
              >
                <Divider orientation="left">{{userObject.meterId}}</Divider>
                <div v-if="userObject.userList == undefined || userObject.userList.length == 0">
                  <span>无非户主用户</span>
                </div>
                <div
                  v-for="(user, userKey) in userObject.userList"
                  :value="user"
                  :key="userKey"
                  style="font-size: 18px;margin: 10px"
                >
                  <Row>
                    <Col span="4" style="text-align:center;">
                      <img :src="user.headimgurl" style="width:25px" />
                    </Col>
                    <Col span="16" style="text-align:left;">{{user.nickname}}</Col>
                    <Col span="4" style="text-align:left;">
                      <Button
                        type="warning"
                        style="float:right"
                        @click="debindother(user, userObject.meterId)"
                      >解除绑定</Button>
                    </Col>
                  </Row>

                  <Divider orientation="left"></Divider>
                </div>
                <Divider orientation="left"></Divider>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </Scroll>
  </div>
</template>

<script>
export default {
  props: {
    customerArray: [],
    personnelArray: [],
    meterArray: [],
    callBack: {
      type: Function
    }
  },
  name: "debind",
  mounted() {
    console.log(this.meterArray);
    if (this.customerArray != undefined && this.customerArray.length > 0) {
      this.hasHouseHolder = true;
      this.getRelationship();
    }
    if (this.personnelArray != undefined && this.personnelArray.length > 0) {
      this.hasPersonnel = true;
    }
    if (this.meterArray != undefined && this.meterArray.length > 0) {
      this.hasNotHouseHolder = true;
    }
  },
  data() {
    return {
      isSpinShow: false,
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      hasPersonnel: false,
      hasHouseHolder: false,
      hasNotHouseHolder: false,
      conditions: {},
      wxUserArray: []
    };
  },
  methods: {
    getRelationship() {
      var idCardList = [];
      for (let i = 0; i < this.customerArray.length; i++) {
        if (this.customerArray[i]["customerIdcard"] != undefined) {
          idCardList.push(this.customerArray[i]);
        }
      }

      if (idCardList.length == 0) {
        return;
      }

      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/getRelationshipWxMeterByIdcard",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          userInfoArray: idCardList
        }),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode == 0) {
            that.wxUserArray = data.body;
            console.log(that.wxUserArray);
            // that.meterList = data.body.resultList;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
          }
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    debind(type, object) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>请确认是否要解绑当前用户？</p>",
        onOk: () => {
          this.isSpinShow = true;
          var that = this;
          console.log(object);
          $.ajax({
            url: "/api/deBind",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify({
              type: type,
              object: object
            }),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Modal.error({
                  title: "提示",
                  content: data.errorInfo
                });
                return;
              } else {
                // 当前用户微信未进行绑定
                that.$Modal.success({
                  title: "提示",
                  content: "解除绑定成功"
                });
                that.getRelationship();
                that.callBack(data);
              }
              console.log(data);
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口调用异常"
              });
            },
            complete: function(XMLHttpRequest, textStatus) {
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    debindother(user, meterId) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>请确认是否要解绑当前用户？</p>",
        onOk: () => {
          this.isSpinShow = true;
          var that = this;
          $.ajax({
            url: "/api/deBindOther",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify({
              user: user,
              meterId: meterId
            }),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Modal.error({
                  title: "提示",
                  content: data.errorInfo
                });
                return;
              } else {
                // 当前用户微信未进行绑定
                that.$Modal.success({
                  title: "提示",
                  content: "解除绑定成功"
                });
                that.getRelationship();
                that.callBack(data);
              }
              console.log(data);
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口调用异常"
              });
            },
            complete: function(XMLHttpRequest, textStatus) {
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    }
  }
};
</script>
